import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'

import { Observable, of as observableOf } from 'rxjs'
import { map, take } from 'rxjs/operators'

import { Kirjanpitaja } from 'app/_jaettu-lemonator/model/kirjanpitaja'
import { KirjanpitajaKopioija } from '../service/kirjanpitaja/kirjanpitaja.kopioija'
import { KirjanpitajaService } from '../service/kirjanpitaja/kirjanpitaja.service'

export interface KirjanpitajaComponentData {
  kirjanpitaja: Kirjanpitaja
}

@Injectable()
export class KirjanpitajaComponentDataResolve implements Resolve<KirjanpitajaComponentData> {
  private existingData: KirjanpitajaComponentData = null

  constructor(
    private kirjanpitajaService: KirjanpitajaService,
    private kirjanpitajaKopioija: KirjanpitajaKopioija,
  ) {}

  asetaOlemassaolevaData(data: KirjanpitajaComponentData) {
    this.existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<KirjanpitajaComponentData> {
    const kirjanpitajanAvain = route.params['kirjanpitajanAvain']
    return this.annaAsiakasObservable(kirjanpitajanAvain).pipe(
      map(kirjanpitaja => {
        const returnValue: KirjanpitajaComponentData = {
          kirjanpitaja: kirjanpitaja,
        }
        return returnValue
      }),
    )
  }

  private annaAsiakasObservable(kirjanpitajanAvain: string): Observable<Kirjanpitaja> {
    if (kirjanpitajanAvain === 'uusi') {
      return observableOf(this.kirjanpitajaKopioija.annaUusiKirjanpitaja())
    }
    if (this.existingData && this.existingData.kirjanpitaja && this.existingData.kirjanpitaja.avain === kirjanpitajanAvain) {
      return observableOf(this.existingData.kirjanpitaja)
    }
    return this.kirjanpitajaService.annaKirjanpitajaObservable(kirjanpitajanAvain).pipe(take(1))
  }
}
